import { toCamelCase } from "@/Common/helpers/toCamelCase";

const resolveSections = (elementId: string) => {
	const sectionsMap: {
		[key: string]: string[];
	} = {
		bodyShopManager: ["DefaultPayPlan", "AppendingConfiguration", "ModalitiesConfiguration"],
		bodyShopProductManager: ["DefaultPayPlan", "AppendingConfiguration", "ModalitiesConfiguration"],
		bodyShopForeman: ["DefaultPayPlan", "AppendingConfiguration", "ModalitiesConfiguration"],
		financeManager: ["DefaultPayPlan", "ChargebackLimits", "ChargebackTypes", "GlobalRanking", "ModalitiesConfiguration"],
		financeDirector: ["DefaultPayPlan", "ChargebackLimits", "ChargebackTypes", "AppendingConfiguration", "ModalitiesConfiguration"],
		generalSalesManager: ["DefaultPayPlan", "ChargebackLimits", "ChargebackTypes", "AppendingConfiguration", "ModalitiesConfiguration"],
		partsCounterAssociate: ["DefaultPayPlan", "AppendingConfiguration", "ModalitiesConfiguration"],
		partsDirector: ["DefaultPayPlan", "AppendingConfiguration", "ModalitiesConfiguration"],
		partsManager: ["DefaultPayPlan", "AppendingConfiguration", "ModalitiesConfiguration"],
		salesAssociate: ["DefaultPayPlan", "ChargebackTypes", "ChargebackLimits", "ModalitiesConfiguration"],
		salesManager: ["DefaultPayPlan", "ChargebackLimits", "ChargebackTypes", "AppendingConfiguration", "ModalitiesConfiguration"],
		serviceDirector: ["DefaultPayPlan", "AppendingConfiguration", "ModalitiesConfiguration"],
		serviceManager: ["DefaultPayPlan", "AppendingConfiguration", "ModalitiesConfiguration"],
		serviceForeman: ["DefaultPayPlan", "AppendingConfiguration", "ModalitiesConfiguration"],
		bodyShopTechnician: ["DefaultPayPlan", "ModalitiesConfiguration"],
		bodyShopPainter: ["DefaultPayPlan", "ModalitiesConfiguration"],
		serviceTechnician: ["DefaultPayPlan", "ModalitiesConfiguration"],
		serviceAdvisor: [
			"DefaultPayPlan",
			"AdvisorsRankingConfiguration",
			"ChargebacksAccountReferences",
			"ChargebackLimits",
			"ModalitiesConfiguration",
		],
		internalServiceAdvisor: [
			"DefaultPayPlan",
			"AdvisorsRankingConfiguration",
			"ChargebacksAccountReferences",
			"ChargebackLimits",
			"ModalitiesConfiguration",
		],
		bodyShopEstimator: [
			"DefaultPayPlan",
			"AdvisorsRankingConfiguration",
			"ChargebacksAccountReferences",
			"ChargebackLimits",
			"ModalitiesConfiguration",
		],
	};

	return sectionsMap[elementId] || [];
};

const resolveSystemPosition = (value: { systemPosition: string }) => {
	if (!value?.systemPosition) {
		return "";
	}
	if (value.systemPosition.startsWith("Sales Associate")) {
		return "Sales Associate";
	}
	if (value.systemPosition.startsWith("Sales Manager")) {
		return "Sales Manager";
	}
	return value.systemPosition;
};

const getMappedPositionsMenu = (mappedPosition: { systemPosition: string; isDepartmental: boolean }[] = []) => {
	const result = mappedPosition.reduce<{ label: string; elementId: string; isDepartmental: boolean; sections: string[] }[]>(
		(acc, value) => {
			const label = resolveSystemPosition(value);
			const isDepartmental = !!value.isDepartmental;
			const elementId = toCamelCase(label) === "fIManager" ? "financeManager" : toCamelCase(label);
			const sections = resolveSections(elementId);
			const alreadyAdded = acc.find((item) => item.elementId === elementId);
			if (!alreadyAdded) {
				return [
					...acc,
					{
						label,
						elementId,
						sections,
						isDepartmental,
					},
				];
			}
			return [...acc];
		},
		[]
	);
	return result.sort((a, b) => a.elementId.localeCompare(b.elementId));
};

export default getMappedPositionsMenu;
